// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'whatwg-fetch'
import Vue from 'vue'
import bootstrap from './boot/bootstrap'
import {
  Actionsheet,
  NavBar,
  Field,
  Popup,
  Loading,
  Checkbox,
  Switch,
  DatetimePicker,
  Button,
  SwipeCell,
  NoticeBar,
  Tab,
  Tabs,
  Cell,
  CellGroup,
  Picker,
  Dialog,
  RadioGroup,
  Radio
} from 'vant'
import App from './App'
import router from './router'
import './components/globals'
import store from './components/mixins/store'

Vue.use(Actionsheet)
  .use(NavBar)
  .use(Field)
  .use(Popup)
  .use(Loading)
  .use(Checkbox)
  .use(Switch)
  .use(DatetimePicker)
  .use(Button)
  .use(SwipeCell)
  .use(NoticeBar)
  .use(Tab)
  .use(Tabs)
  .use(Cell)
  .use(CellGroup)
  .use(Picker)
  .use(Dialog)
  .use(RadioGroup)
  .use(Radio)

Vue.config.productionTip = false

// 添加通讯总线
let eventhub = new Vue()
Vue.prototype.$bus = eventhub
// let eventsubhub = new Vue()
// Vue.prototype.$bus.$children.push(eventsubhub)

// 全局store 对象及方法
Vue.mixin(store)

/* eslint-disable no-new */
bootstrap().then(() => {
  new Vue({
    el: '#app',
    router,
    components: { App },
    render: createElement => createElement(App)
  })
})

// hack for :active color enable when click
document.body.addEventListener('touchstart', () => {}, false)
